import { actionTypes } from 'BASE/store/types';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { urlCombine } from 'BASE/common/util/util.apiProxy';

export default {
    data: function () {
        return {
            iosPlistPath: '',
            androidAppUrl: '',
            GuideUrlIsComplete: false,
            IsInitComplete: false,

            AFKAndroidUrl: '',
            AFKiosUrl: '',
            AFKPcUrl: '',
            AFKAndroidFile: '',
            AFKPcFile: '',
            IOSPlistPath: '',
            LoginUrl: '',
            CordovaAppVersion: '',
            LegendAFKAndroidUrl: '',
            LegendAFKiosUrl: '',
            LegendAFKPCUrl: '',
            LegendAFKTelegramGuideUrl: '',
            LegendAFKVpnGuideUrl: '',
            SmartAFKUrl:'',

            QrcodeOptions: {
                width: 170,
                margin: 1
            },
            SwitchToApp: true,
            SaveStorage: false,
        };
    },
    components: {
        qrcode: VueQrcode
    },
    computed: {
        originURL: function () {
            var origin = "";
            if (!window.location.origin) {
                origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
            }
            else {
                origin = document.location.origin;
            }

            return ENVIRONMENT.CORDOVA? urlCombine("") : origin;
        }
    },
    methods: {
        AndroidOrPcFile(extension) {
            let merchantCode = typeof this.$store.state.userinfo.merchantCode == "string" ? this.$store.state.userinfo.merchantCode : "";

            if(merchantCode == "") return "javascript:void(0);";

            return `${this.originURL}/d/${merchantCode.toLowerCase()}/${merchantCode.toUpperCase()}.${extension}`;
        },
        FileName(fileName) {
            let merchantCode = typeof this.$store.state.userinfo.merchantCode == "string" ? this.$store.state.userinfo.merchantCode : "";

            if(merchantCode == "") return "javascript:void(0);";

            return `${this.originURL}/d/${merchantCode.toLowerCase()}/${fileName}`;
        },
        switchPage(showDownloadPage) {
            this.SwitchToApp = showDownloadPage;
        },
        windowOpen(url) {
            window.open(url, "_blank");
        },
        InitCallback() {
            // 需要實作的再實作
        },
        getUrl(path, file, defaultAction = "") {
            if (path) {
                return path;
            } else if (file) {
                return this.FileName(file);
            } else {
                return defaultAction;
            }
        },
        setAppUrl(result) {
            this.iosPlistPath = this.getUrl(result.IOSPlistPath, null, `${this.originURL}/IOSDownload`);
            this.androidAppUrl = this.getUrl(result.AndroidAPPUrl, result.AndroidAPPFile, this.AndroidOrPcFile("apk"));
        },
        setAFKUrl(result) {
            this.AFKAndroidUrl = this.getUrl(result.AFKAndroidUrl, result.AFKAndroidFile);
            this.AFKiosUrl = result.AFKiosUrl || "";
            this.AFKPcUrl = this.getUrl(result.AFKPcUrl, result.AFKPcFile);
        },
        setLegendAFKUrl(result) {
            this.LegendAFKAndroidUrl = this.getUrl(result.LegendAFKAndroidUrl, result.LegendAFKAndroidFile);
            this.LegendAFKiosUrl = result.LegendAFKiosUrl || "";
            this.LegendAFKPCUrl = this.getUrl(result.LegendAFKPCUrl, result.LegendAFKPCFile);
        },
        async InitSKY() {
            try {
                let result = await $.post('/api/AFK/GetAFKConfig');
                if (result) {
                    this.setAppUrl(result);
                    this.setAFKUrl(result);
                    this.setLegendAFKUrl(result);

                    this.InitCallback();
                    if (this.SaveStorage) {
                        this.$store.dispatch(actionTypes.AFK_URL_SET, { afkUrlSet: result });
                    }

                    this.IsInitComplete = true;
                }
            } catch (err) {
                console.error(err);
            }
        }
    },
    async mounted() {
        await this.InitSKY();
    }
}
